export default "__VITE_ASSET__7ba6bca3__"